// Generated by CoffeeScript 2.7.0
String.prototype.underscore = function() {
  return this.trim().replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').replace(/::/, '/').toLowerCase();
};

String.prototype.demodulize = function() {
  var index;
  index = this.lastIndexOf('::');
  if (index >= 0) {
    return this.slice(index + 2);
  } else {
    return this.slice();
  }
};
